export const FETCH_USER = 'fetch_user';
export const REGISTER_USER = 'register_user';
export const FETCH_REVIEWS = 'fetch_reviews';
export const WAITING = 'waiting';
export const ERROR = 'ERROR';
export const FETCH_PAYMENT_DETAILS = 'fetch_payment_details';



// WEBPACK FOOTER //
// ./src/actions/types.js